import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import applicationVersion from '../../../../../application_version.txt';
import type { RootState } from '../../../store/store';
import { ROUTES } from '../../../utils/routes';
import AdminAutoDemo from '../AdminAutoDemo';

const Footer: React.FC = () => {
  const isAdmin = useSelector((state: RootState) => state.auth.isAdmin);
  const company = useSelector((state: RootState) => state.auth.company);

  const blogHref = company?.brandingSettings?.color1
    ? `/blog/company/${company.siren}`
    : ROUTES.EXTERNAL_BLOG;

  return (
    <div className="mt-10 mb-4 text-center text-xs text-gray-400">
      {applicationVersion}
      <span className="mx-1.5">·</span>
      <a
        href={blogHref}
        target="_blank"
        className="text-gray-400 transition-colors hover:text-gray-600 hover:underline"
        rel="noreferrer"
      >
        Accéder au blog
      </a>
      {isAdmin && (
        <>
          <span className="mx-1.5">·</span>
          <Link
            to={ROUTES.ADMIN_COMPANIES_LIST}
            className="text-gray-400 transition-colors hover:text-gray-600 hover:underline"
          >
            Accéder au BO
          </Link>
          <span className="mx-1.5">·</span>
          <AdminAutoDemo />
        </>
      )}
    </div>
  );
};

export default Footer;
